import React from 'react'
import { Button, makeStyles } from '@material-ui/core'
import {
  defaultC,
  negativeB,
  negativeC,
  primaryB,
  primaryBHover,
  primaryC,
  purple,
  secondaryB,
  secondaryC
} from 'asterX-UI/DataDisplay/AsterChip'
import PropTypes from 'prop-types'
import { defaultB } from 'asterX-UI/constants/colors'
import { SUCCESS_COLORS } from '../colors.constant'

const useStyles = makeStyles(theme => ({
  root: {
    padding: '10px 18px',

    borderRadius: 8,
    fontWeight: 600,
    fontSize: 16,
    transition: 'none',
    textTransform: 'none'
  },
  small: {
    padding: '0 5px 0 0'
  },
  notActive: {
    backgroundColor: '#fff' + '!important',
    color: '#94A1B4',
    border: '1px solid #fff'
  },
  default: {
    backgroundColor: defaultB + '!important',
    color: defaultC,
    border: '1px solid #DCE6F3'
  },
  bordered: {
    backgroundColor: defaultB + '!important',
    color: purple,
    border: '1px solid #DCE6F3',
    '&:hover': {
      color: purple
    }
  },
  primary: {
    backgroundColor: primaryB + '!important',
    color: primaryC,
    border: '1px solid #fff',
    transition: 'all 0.3s',
    '&:hover': {
      color: primaryC,
      backgroundColor: primaryBHover + '!important'
    }
  },
  secondary: {
    backgroundColor: secondaryB + '!important',
    color: secondaryC,
    border: '1px solid #fff'
  },
  positive: {
    backgroundColor: SUCCESS_COLORS[500] + '!important',
    color: '#FFFFFF'
  },
  negative: {
    backgroundColor: negativeB + '!important',
    color: negativeC,
    border: '1px solid #fff'
  },
  disabled: {
    backgroundColor: '#DCE6F3' + '!important',
    color: '#94A1B4'
  },
  borderedBtn: {
    height: 'fit-content',
    minHeight: 0,
    fontSize: 12,
    padding: '5px 10px',
    '& .MuiButton-startIcon': {
      marginLeft: 0,
      marginRight: 0
    }
  }
}))

const AsterButton = ({ color, className, size, ...other }) => {
  const classes = useStyles()
  return (
    <Button
      className={
        other.disabled
          ? [
              color === 'bordered' ? '' : classes.disabled,
              className,
              color === 'bordered' ? classes.borderedBtn : '',
              classes[size]
            ].join(' ')
          : [
              color === 'bordered' ? '' : classes.root,
              classes[color],
              className,
              color === 'bordered' ? classes.borderedBtn : '',
              classes[size]
            ].join(' ')
      }
      {...other}
    />
  )
}

export default AsterButton

AsterButton.propTypes = {
  color: PropTypes.oneOf([
    'notActive',
    'default',
    'primary',
    'bordered',
    'secondary',
    'positive',
    'negative'
  ]),
  disabled: PropTypes.bool,
  onClick: PropTypes.func
}
